export const types = {
  DISPLAY_NAVBAR: 'Navbar/display',
  SET_FIXED: 'Navbar/setFixed',
  SET_LOCKED: 'Navbar/setLocked'
}

export default {
  displayNavbar: function(visible) {
    return {
      type: types.DISPLAY_NAVBAR,
      visible
    }
  },
  setFixed: function(fixed) {
    return {
      type: types.SET_FIXED,
      fixed
    }
  },
  setLocked: function(locked) {
    return {
      type: types.SET_LOCKED,
      locked
    }
  }
}
